import { FC } from 'react';

interface Props {
  text: string;
}

const WinnerBadge: FC<Props> = ({ text }) => {
  return (
    <div className='winner-team-badge inline-flex p-1 rounded-2 text-statusBadgeTextColor bg-statusBadgeBgColor text-2 uppercase'>
      {text}
    </div>
  );
};

export default WinnerBadge;
